import { COVERGO_SAAS_DEV } from "../consts.js"

export const wfp = {
	"wfp-dev-studio.quote.hk": {
		appConfig: {
			tenantId: "wfp_dev",
			appId: "admin_portal"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
